import React from "react";
import { BrowserRouter as Router, Route, withRouter } from "react-router-dom";
import { StyleSheet, Navigator } from "react-1app";
import { connect, Provider } from "react-redux";
import Home from "./views/Home.js";
import Novidades from "./views/Novidades.js";
import Receitas from "./views/Receitas.js";
import Manual from "./views/Manual.js";
import Garantia from "./views/Garantia.js";
import Gerenciador from "./views/Gerenciador.js";
import Login from "./views/Login.js";

export default class Navegation extends React.Component {
  componentDidMount() {
    this.navigator.history = this.router.history;
  }
  render() {
    return (
      <Provider store={this.props.store}>
        <Router ref={v => (this.router = v)}>
          <Navigator
            ref={v => (this.navigator = v)}
            actions={this.props.actions}
            store={this.props.store}
            style={{ flex: 1 }}
          >
            <Route
              exact
              path="/"
              component={withRouter(connect(this.props.mapStateToProps)(Home))}
            />
            
          </Navigator>
        </Router>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/index.pages.js